var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.32336 2.586C9.73586 1.74933 10.9284 1.74933 11.3409 2.586L13.3059 6.56683L17.7 7.20516C18.6225 7.33933 18.9909 8.4735 18.3234 9.12433L15.1434 12.2243L15.8942 16.5993C16.0525 17.5185 15.0875 18.2193 14.2617 17.786L10.3317 15.7193L6.40253 17.786C5.57753 18.2193 4.61253 17.5193 4.76919 16.5993L5.52003 12.2243L2.34086 9.12433C1.67336 8.47433 2.04169 7.33933 2.96419 7.20516L7.35836 6.56683L9.32336 2.586Z","fill":"#E0E0E0"}));
}

Star.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Star;

Star.default = Star;
